<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img :src="logo" alt="logo company" width="300" >
                  <h1 class="flex my-4 primary--text text-center"></h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" name="login" label="Login" type="text" v-model="model.email"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="authenticate" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { login } from './../helpers/auth';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    model: {
      email: '',
      password: ''
    },
    logo: process.env.LOGO_PATH,
    error: null
  }),
  computed: {
    ...mapGetters(['loading'])
  },
  methods: {
    authenticate () {
      let route = 'Surveys';
      this.$store.commit('setLoading', true);
      this.$store.dispatch('login');

      login(this.model).then(res => {        
        if (res.is_admin) {
          route = 'Clients';
        }
        this.$store.commit('loginSuccess', res);
        this.$router.push({
          name: route,
        });
        this.$store.dispatch('setLoading', false);
      }).catch(error => {
        this.$store.dispatch('setLoading', false);
      });
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue